document.addEventListener("DOMContentLoaded", function () {
  const expandableItems = document.querySelectorAll(".expandable-item");
  const activeImage = document.querySelector(".active-image");
  let isAnimating = false;

  expandableItems.forEach((item) => {
    // Handle hover events for desktop
    item.addEventListener("mouseenter", function () {
      if (window.innerWidth >= 750) {  // Only on desktop
        this.classList.add('is-hovered');
        const image = this.dataset.image;
        if (image && image !== activeImage.src && !isAnimating) {
          isAnimating = true;
          activeImage.style.opacity = "0";
          activeImage.style.transform = "scale(0.98)";
          
          setTimeout(() => {
            activeImage.src = image;
            activeImage.style.opacity = "1";
            activeImage.style.transform = "scale(1)";
            setTimeout(() => {
              isAnimating = false;
            }, 300);
          }, 300);
        }
      }
    });

    // Handle mouse leave
    item.addEventListener("mouseleave", function () {
      if (window.innerWidth >= 750) {  // Only on desktop
        this.classList.remove('is-hovered');
      }
    });

    // Handle click events for mobile
    item.addEventListener("click", function (e) {
      if (window.innerWidth < 750) {  // Only on mobile
        if (isAnimating) return; // Prevent multiple clicks during animation

        // Remove active class from all other items
        expandableItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-hovered');
          }
        });

        // Toggle hover class for clicked item
        const wasHovered = this.classList.contains('is-hovered');
        this.classList.toggle('is-hovered');

        const image = this.dataset.image;
        if (image && image !== activeImage.src && !wasHovered) {
          isAnimating = true;
          activeImage.style.opacity = "0";
          activeImage.style.transform = "scale(0.98)";
          
          setTimeout(() => {
            activeImage.src = image;
            activeImage.style.opacity = "1";
            activeImage.style.transform = "scale(1)";
            setTimeout(() => {
              isAnimating = false;
            }, 300);
          }, 300);
        }
      }
    });
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Reset all animations and states on resize
      isAnimating = false;
      activeImage.style.opacity = "1";
      activeImage.style.transform = "scale(1)";
      // Remove hover states on resize
      expandableItems.forEach(item => item.classList.remove('is-hovered'));
    }, 250);
  });
});
